import io from "socket.io-client";
import Cookies from "universal-cookie";
import { config, TOKEN_NAME } from "../config";

const cookies = new Cookies();

class WSService {
  constructor() {
    this.socket = null;
    this.connected = false;
    this.initializationInProgress = false;
  }

  initializeSocket = async () => {
    if (this.initializationInProgress) {
      return;
    }
    
    if (this.socket && this.connected) {
      return;
    }

    const token = cookies.get(TOKEN_NAME);

    if (!token) {
      return;
    }

    try {
      this.initializationInProgress = true;
      
      if (this.socket) {
        this.socket.disconnect();
        this.socket.removeAllListeners();
        this.socket = null;
      }

      this.socket = io(config.chatapiurl, {
        extraHeaders: {
          Authorization: `${token}`,
        },
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
      });
      
      this.socket.on("connect", () => {
        this.connected = true;
        this.initializationInProgress = false;
      });
      
      this.socket.on("disconnect", () => {
        this.connected = false;
      });
      
      this.socket.on("error", (error) => {
        this.initializationInProgress = false;
      });
      
      this.socket.on("connect_error", (error) => {
        this.initializationInProgress = false;
      });
      
    } catch (error) {
      this.initializationInProgress = false;
    }
  };

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.connected = false;
      this.socket = null;
    }
  }

  emit(event, data = {}, cb) {
    if (!this.socket) {
      return cb && cb({ success: false, error: "Socket not connected" });
    }
    this.socket.emit(event, data, cb);
  }
  
  on(event, cb) {
    if (!this.socket) {
      console.error("Cannot add listener - socket not initialized");
      return;
    }
    this.socket.on(event, cb);
  }
  
  removeListener(eventName, callback) {
    if (this.socket) {
      if (callback) {
        this.socket.off(eventName, callback);
      } else {
        this.socket.removeListener(eventName);
      }
    }
  }

  isConnected() {
    return this.connected;
  }
}

const socketServices = new WSService();

export default socketServices;
